import { defineComponent as _defineComponent } from 'vue';
import VideoBtnGroup from '@blade-sxp/monitoring-center/pages/components/video-btn-group.vue';
import VideoBoxGroup from '@blade-sxp/monitoring-center/pages/components/video-box-group.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'video-stream',
    setup(__props) {
        return { __sfc: true, VideoBtnGroup, VideoBoxGroup };
    }
});
